import React from 'react';
import {
  InstructionWrapper,
  List,
  TextField
} from '../../../../components/fields';
import { publish, useStateReducer } from '../../../../hooks';
import { validateObject } from '../../../../utilities';
import './_styles.scss';

interface ViewItemProps {
  data: any;
}

export default function ViewItem({ data }: ViewItemProps) {
  const { name, listCards, listDesc } = data;

  const [state, setState] = useStateReducer({
    ...data
  });

  const selectedCard = state.selectedCard
    ? listCards.filter((c: any) => c.label === state.selectedCard)[0]
    : null;

  const handleChange = (prop: string, value: any) => {
    setState({ [prop]: value });
    publish('notification', { ...state, [prop]: value });
  };

  const hasError = (prop: string) => (errors[prop] ? true : false);

  const errors = validateObject(
    {
      message: { regex: /.+/, message: 'This field is required.' },
      selectedCard: { regex: /.+/, message: 'This field is required.' },
      title: { regex: /.+/, message: 'This field is required.' }
    },
    state
  );

  return (
    <div className='order-item'>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingRight: '2%'
        }}
      >
        <h2 className='heading'>{name ? name : 'No Title'}</h2>
        <div
          style={{
            display: 'flex'
          }}
        ></div>
      </div>
      <InstructionWrapper
        text={`Please select a ${listDesc}`}
        error={errors['selectedCard']}
      >
        <List
          label={`${listDesc}s`}
          onChange={(_, v) => {
            handleChange('selectedCard', v?.label ?? null);
            handleChange('selectedCard_id', v?._id ?? null);
          }}
          value={selectedCard}
          options={listCards}
          error={hasError('selectedCard')}
          getOptionLabel={(o) => o.label}
          getOptionValue={(o) => o.label}
          groupBy={(o) => o.label.substring(0, 1)}
          isOptionEqualToValue={(o, v) => o.label === v.label}
        />
      </InstructionWrapper>
      <div
        style={{
          paddingTop: '24px'
        }}
      ></div>
      <InstructionWrapper
        text='Enter notification message.'
        error={errors['message']}
      >
        <TextField
          label='Notification body'
          multiline
          onChange={(e) => handleChange('message', e.target.value)}
          value={state.message}
          error={hasError('message')}
        ></TextField>
      </InstructionWrapper>
      <InstructionWrapper
        text='Enter notification title.'
        error={errors['title']}
      >
        <TextField
          label='Notification title'
          multiline
          onChange={(e) => handleChange('title', e.target.value)}
          value={state.title}
          error={hasError('title')}
        ></TextField>
      </InstructionWrapper>
    </div>
  );
}
